/**
 * Shared pronouns option list + helpers for the PronounsPicker.
 *
 * The stored value is a plain string (the backend field is Optional[str]) —
 * no enum, no migration. Matching against PRONOUN_OPTIONS is case- and
 * space-sensitive so legacy values (e.g. "He / Him") are preserved verbatim
 * under the "Other…" branch and never coerced.
 */

export const PRONOUN_OPTIONS = [
    { value: 'he/him', label: 'he/him' },
    { value: 'she/her', label: 'she/her' },
    { value: 'they/them', label: 'they/them' },
    { value: 'he/they', label: 'he/they' },
    { value: 'she/they', label: 'she/they' },
];

// Sentinel value used by the <select> for the "Other…" option. Never stored.
export const PRONOUN_OTHER = '__other__';

export const PRONOUN_MAX_LENGTH = 30;

/**
 * Returns the value the <select> should display for a stored pronouns string:
 *  - '' if blank
 *  - the option value if it exactly matches one of PRONOUN_OPTIONS
 *  - PRONOUN_OTHER otherwise (legacy / self-described values)
 */
export function pronounSelectValue(value) {
    if (!value) return '';
    return PRONOUN_OPTIONS.some(o => o.value === value) ? value : PRONOUN_OTHER;
}
